import { render, staticRenderFns } from "./ActivityShow.vue?vue&type=template&id=c03fb568&scoped=true&"
import script from "./ActivityShow.vue?vue&type=script&lang=js&"
export * from "./ActivityShow.vue?vue&type=script&lang=js&"
import style0 from "./ActivityShow.vue?vue&type=style&index=0&id=c03fb568&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c03fb568",
  null
  
)

export default component.exports